<div [ngClass]="{ 'bg-grey-card py-5': data.card_loader_color == '0' }"
  *ngIf="!isArgomentiPage && !isNewsPage && !isServicePage && !isDocumentPage && !isPersonPage && !isOrgUnitPage">
  <div [ngClass]="{ 'py-5': data.card_loader_color == '1' }" class="container">
    <h2 [ngClass]="{ 'pt-5': data.card_loader_title === null }" class="title-xxlarge mb-4">
      {{ data.card_loader_title ?? "" }}
    </h2>
    <div class="row g-4">
      <ng-container *ngFor="let card of data.card_loader_cards">
        <div class="col-md-6 col-lg-4">
          <div class="cmp-card-simple card-wrapper pb-0 rounded border border-light">
            <div class="card shadow-sm rounded">
              <div class="card-body">
                <a [href]="card.alias" class="text-decoration-none" data-element="management-category-link">
                  <h3 class="card-title t-primary">{{ card.title }}</h3>
                </a>
                <p class="text-secondary mb-0" [innerHTML]="card.description"></p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div [ngClass]="{ 'bg-grey-card py-5': data.card_loader_color == '0' }" *ngIf="isArgomentiPage">
  <div [ngClass]="{ 'py-5': data.card_loader_color == '1' }" class="container">
    <div class="row" *ngIf="isLoading">
      <div class="progress progress-indeterminate">
        <span class="visually-hidden">In elaborazione...</span>
        <div class="progress-bar" role="progressbar"></div>
      </div>
    </div>
    <h2 [ngClass]="{ 'pt-5': data.card_loader_title === null }" class="title-xxlarge mb-4" *ngIf="!isLoading">
      {{ data.card_loader_title ?? "" }}
    </h2>
    <div class="row g-4">
      <ng-container *ngFor="let card of data.card_loader_cards">
        <div class="col-md-6 col-lg-4">
          <div class="cmp-card-simple card-wrapper pb-0 rounded border border-light">
            <div class="card shadow-sm rounded">
              <div class="card-body">
                <a [href]="card.alias" class="text-decoration-none" [attr.data-element]="dataElement">
                  <h3 class="card-title t-primary">{{ card.title }}</h3>
                </a>
                <p class="text-secondary mb-0" [innerHTML]="card.description"></p>
                <div class="mt-4" *ngIf="card.related_tags.length">
                  <ul class="d-flex flex-wrap gap-1">
                    <li *ngFor="let tag of card.related_tags">
                      <a class="chip chip-simple" [href]="tag?.path?.alias" data-focus-mouse="false">
                        <!-- data-element="topic-element" -->
                        <span class="chip-label">{{ tag.title }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<section id="notizie" *ngIf="isNewsPage && !isArgomentiPage && !isDocumentPage">
  <div class="container py-5" #top>
    <app-input-search (searchEvent)="onSearch($event)" *ngIf="!isLoading"></app-input-search>
    <div class="row g-4">
      <div class="row" *ngIf="isLoading">
        <div class="progress progress-indeterminate">
          <span class="visually-hidden">In elaborazione...</span>
          <div class="progress-bar" role="progressbar"></div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4" *ngFor="let news of data.card_loader_cards">
        <div class="card-wrapper border border-light rounded shadow-sm">
          <div class="card no-after rounded">
            <div class="img-responsive-wrapper" *ngIf="
                news && news.news_image && news.news_image.field_media_image
              ">
              <div class="img-responsive img-responsive-panoramic">
                <figure class="img-wrapper">
                  <img [src]="news.news_image?.field_media_image?.uri?.url"
                    [title]="news?.news_image?.field_media_image?.meta?.title"
                    [alt]="news?.news_image?.field_media_image.meta?.alt" />
                </figure>
              </div>
            </div>
            <div class="card-body">
              <div class="category-top">
                <a class="category text-decoration-none" [href]="'/novita/' + news.news_type?.field_breadcrumb">{{
                  news.news_type?.name }}</a>
                <span class="data">{{
                  news.news_publication_date | date : "dd MMM yyyy"
                  }}</span>
              </div>
              <a [href]="news.path?.alias" class="text-decoration-none" data-element="news-category-link">
                <h3 class="card-title">{{ news.title }}</h3>
              </a>
              <p class="card-text pb-3 text-secondary" [innerHTML]="stringSubstr(news.news_description, 0, 250)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end card-->
    <app-paginator [currentPage]="currentPage" [totalPages]="totalPages" (pageChanged)="onPageChange($event, 'news')"
      *ngIf="!isLoading">
    </app-paginator>
  </div>
</section>

<section id="org_unit"
  *ngIf="isOrgUnitPage && !isPersonPage && !isArgomentiPage && !isNewsPage && !isServicePage && !isDocumentPage">
  <div class="container py-5" #top>
    <app-input-search (searchEvent)="onSearch($event, 'org_unit')" *ngIf="!isLoading"></app-input-search>
    <div class="row g-4">
      <div class="row" *ngIf="isLoading">
        <div class="progress progress-indeterminate">
          <span class="visually-hidden">In elaborazione...</span>
          <div class="progress-bar" role="progressbar"></div>
        </div>
      </div>
    </div>
    <div class="row g-4">
      <div class="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
        <div class="card card-teaser card-teaser-image card-flex no-after rounded shadow-sm border border-light mb-0"
          *ngFor="let org_unit of data.card_loader_cards">
          <div class="card-image-wrapper with-read-more">
            <div class="card-body p-3">
              <div class="category-top">
                <span class="title-xsmall-semi-bold fw-semibold">{{org_unit?.org_unit_type?.name}}</span>
              </div>
              <h3 class="card-title text-paragraph-medium u-grey-light">
                <a [href]="org_unit?.path?.alias" class="text-decoration-none">
                  {{org_unit?.title}}
                </a>
              </h3>
              <p class="text-paragraph-card u-grey-light m-0" [innerHTML]="org_unit?.org_unit_short_description"></p>
            </div>
            <div class="card-image card-image-rounded pb-5"
              *ngIf="org_unit?.org_unit_image?.field_media_image?.uri?.url">
              <img [src]="org_unit?.org_unit_image?.field_media_image?.uri?.url"
                [alt]="org_unit.org_unit_image?.field_media_image?.meta?.alt">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end card-->
    <app-paginator [currentPage]="currentPage" [totalPages]="totalPages"
      (pageChanged)="onPageChange($event, 'org_unit')" *ngIf="!isLoading && paginatorVisible">
    </app-paginator>
  </div>
</section>

<section id="document" *ngIf="isDocumentPage && !isArgomentiPage && !isNewsPage">
  <div class="container py-5" #top>
    <app-input-search (searchEvent)="onSearch($event, 'public_document')" *ngIf="!isLoading"></app-input-search>
    <div class="row g-4">
      <div class="row" *ngIf="isLoading">
        <div class="progress progress-indeterminate">
          <span class="visually-hidden">In elaborazione...</span>
          <div class="progress-bar" role="progressbar"></div>
        </div>
      </div>
      <div class="col-md-6 col-xl-4" *ngFor="let document of data.card_loader_cards">
        <div class="card-wrapper border border-light rounded shadow-sm">
          <div class="card no-after rounded">
            <div class="img-responsive-wrapper" *ngIf="
                document && document.field_image && document.field_image.field_media_image
              ">
              <div class="img-responsive img-responsive-panoramic">
                <figure class="img-wrapper">
                  <img [src]="document.field_image?.field_media_image?.uri?.url"
                    [title]="document?.field_image?.field_media_image?.meta?.title"
                    [alt]="document?.field_image?.field_media_image.meta?.alt" />
                </figure>
              </div>
            </div>
            <div class="card-body">
              <div class="category-top">
                <p>
                  <span class="category text-decoration-none">{{ document.public_document_type?.name }}</span>
                </p>

              </div>
              <a [href]="document.path?.alias" class="text-decoration-none" data-element="document-category-link">
                <h3 class="card-title">{{ document.title }}</h3>
              </a>
              <p class="card-text pb-3 text-secondary"
                [innerHTML]="stringSubstr(document.public_document_short_desc, 0, 250)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end card-->
    <app-paginator [currentPage]="currentPage" [totalPages]="totalPages"
      (pageChanged)="onPageChange($event, 'public_document')" *ngIf="!isLoading">
    </app-paginator>
  </div>
</section>

<section id="person" *ngIf="isPersonPage && !isArgomentiPage && !isNewsPage && !isServicePage && !isDocumentPage">
  <div class="container py-5" #top>
    <app-input-search (searchEvent)="onSearch($event, 'public_person')" *ngIf="!isLoading"></app-input-search>
    <div class="row g-4">
      <div class="row" *ngIf="isLoading">
        <div class="progress progress-indeterminate">
          <span class="visually-hidden">In elaborazione...</span>
          <div class="progress-bar" role="progressbar"></div>
        </div>
      </div>
    </div>
    <div class="row g-4">
      <div class="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal card-teaser-block-3">
        <div class="card card-teaser card-teaser-image card-flex no-after rounded shadow-sm border border-light mb-0"
          *ngFor="let person of data.card_loader_cards">
          <div class="card-image-wrapper with-read-more">
            <div class="card-body p-3">
              <div class="category-top">
                <span class="title-xsmall-semi-bold fw-semibold">{{person?.person_type?.name}}</span>
              </div>
              <h3 class="card-title text-paragraph-medium u-grey-light">
                <a [href]="person?.path?.alias" class="text-decoration-none">
                  {{person?.title}}
                </a>
              </h3>
              <p class="text-paragraph-card u-grey-light m-0" [innerHTML]="person?.person_body?.processed"></p>
            </div>
            <div class="card-image card-image-rounded pb-5" *ngIf="person?.person_image?.field_media_image?.uri?.url">
              <img [src]="person?.person_image?.field_media_image?.uri?.url"
                [alt]="person.person_image?.field_media_image?.meta?.alt">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end card-->
    <app-paginator [currentPage]="currentPage" [totalPages]="totalPages"
      (pageChanged)="onPageChange($event, 'public_person')" *ngIf="!isLoading">
    </app-paginator>
  </div>
</section>

<!-- service case -->
<ng-container *ngIf="isServicePage && !isArgomentiPage && !isNewsPage">
  <div class="row" *ngIf="isLoading">
    <div class="progress progress-indeterminate">
      <span class="visually-hidden">In elaborazione...</span>
      <div class="progress-bar" role="progressbar"></div>
    </div>
  </div>

  <!-- service search -->
  <div class="bg-grey-card pt-3" *ngIf="!isLoading">
    <div class="container">
      <div class="row">
        <div class="offset-1 col-10 col-lg-10 pt-lg-50 pb-lg-50">
          <div class="cmp-input-search">
            <div class="form-group autocomplete-wrapper mb-2 mb-lg-4">
              <div class="input-group">
                <label for="autocomplete-autocomplete-three" class="visually-hidden">Cerca una parola chiave</label>
                <input #searchInput (keyup.enter)="search(searchInput.value, true)" type="search"
                  class="autocomplete form-control" placeholder="Cerca una parola chiave"
                  id="autocomplete-autocomplete-three" name="autocomplete-three" />

                <div class="input-group-append">
                  <button class="btn btn-primary" type="button" id="button-3" (click)="search(searchInput.value, true)">
                    Invio
                  </button>
                </div>

                <span class="autocomplete-icon" aria-hidden="true">
                  <svg class="icon icon-sm icon-primary">
                    <use href="/bootstrap-italia/dist/svg/sprites.svg#it-search"></use>
                  </svg>
                </span>
              </div>
            </div>
          </div>

          <ng-container *ngIf="searchResults().length; else noResult">
            <p class="mb-4">
              <strong>{{ totalResult }} </strong>servizi trovati
            </p>
            <app-card *ngFor="let item of searchResults()" [title]="item.title" [description]="item.shortDescription"
              [tipologia]="item?.category" [link]="item?.path" [dataElement]="dataElement"></app-card>
          </ng-container>

          <ng-template #noResult>
            <span class="mb-5 d-flex justify-content-center">Nessun risultato trovato.</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>